import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const pblDeleteApi = createAsyncThunk(
  "auth/pbl/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.delete(apiRoutes.projectBasedAction(`${id}`, 1));
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const pblDeleteSlice = createSlice({
  name: "pbl delete",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(pblDeleteApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(pblDeleteApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(pblDeleteApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const pblDeleteReducer = pblDeleteSlice.reducer;
